"use client";

import config from '../../../config';
import ContactInput from "@/components/ContactUs/ContactInput";
import ContactEmail from "@/components/ContactUs/ContactEmail";
import { useEffect, useState } from 'react';
import { useTranslations, useLocale } from 'next-intl';
import { getLocaleName } from '@/i18n/locales';


const ContactUS = () => {
  const t = useTranslations('contactUs');
  const locale = useLocale();
  const localeName = getLocaleName(locale);
  const [authorFullName, setAuthorFullName] = useState("");
  const [userInquiry, setUserInquiry] = useState("");
  const [authorEmail, setAuthorEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");
  const { apiBaseUrl } = config;

  // ← NEW: helper to reset form
  const clearForm = () => {
    setAuthorFullName("");
    setAuthorEmail("");
    setUserInquiry("");
    setIsButtonDisabled(true);
  };



  const handleValidityChange = (isValid) => {
    setIsValidEmail(isValid);
  };

  // disabling captcha
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
  //   script.async = true;
  
  //   script.onload = () => {
  //     const tryRenderCaptcha = () => {
  //       if (window.turnstile && captchaRef.current instanceof HTMLElement) {
  //         const widgetId = window.turnstile.render(captchaRef.current, {
  //           sitekey,
  //           callback: (token) => {
  //             setCaptchaToken(token);
  //           },
  //         });
  //         setCaptchaWidgetId(widgetId);
  
    
  //         setTimeout(() => {
  //           const token = window.turnstile.getResponse(widgetId);
  //           if (token) setCaptchaToken(token);
  //         }, 200);
  //       } else {
      
  //         setTimeout(tryRenderCaptcha, 50);
  //       }
  //     };
  
  //     tryRenderCaptcha();
  //   };
  
  //   document.body.appendChild(script);
  //   return () => document.body.removeChild(script);
  // }, []);
  

  useEffect(() => {
    const isFormValid = authorFullName && isValidEmail && userInquiry;
    setIsButtonDisabled(!isFormValid || isSubmitting);
  }, [authorFullName, isValidEmail, userInquiry, isSubmitting]);

  // New: submit form to Laravel endpoint
  // ← UPDATED: submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const payload = {
      fullName: authorFullName,
      email: authorEmail,
      localization: localeName,
      message: userInquiry,
    };
    try {
      const response = await fetch(apiBaseUrl + '/contact/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        setModalType("success");
        setModalMessage(t('successMessage'));
        clearForm();
      } else {
        setModalType("error");
        setModalMessage(t('errorMessage'));
      }
    } catch (err) {
      console.error('Error sending contact form:', err);
      setModalType("error");
      setModalMessage(t('errorMessage'));
    } finally {
      setShowModal(true);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* ← NEW: Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm text-center">
            <p className={`text-lg font-semibold mb-4 ${modalType === 'success' ? 'text-green-600' : 'text-red-600'}`}>
              {modalMessage}
            </p>
            <button
              onClick={() => setShowModal(false)}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
            >
              {t('close')}
            </button>
          </div>
        </div>
      )}

      <section className="max-w-[740px] w-full mx-auto px-[20px] py-[60px] relative">
        <h2 className="text-center text-[44px] font-bold text-gray mb-[40px]">{t('title')}</h2>
        <div className="flex justify-center items-center gap-[30px] mb-[40px] flex-col md:flex-row">
          <div className="w-full ">
            <p className="mb-[10px]">{t('fullName')}</p>
            <ContactInput
              placeholder={t('fullNamePlaceholder')}
              label=""
              value={authorFullName}
              onChange={setAuthorFullName}
              maxLength="64"
            />
          </div>

        </div>
        <div className="mb-[40px]">
          <p className="mb-[10px]">{t('yourMail')}</p>
          <ContactEmail
            placeholder={t('mailPlaceholder')}
            title=""
            label=""
            value={authorEmail}
            onChange={setAuthorEmail}
            onValidityChange={handleValidityChange}
            height="60px"
            placeholderSize="16px"
          />
        </div>

        <div className="mb-[40px]">
          <p className="mb-[10px]">{t('howCanWeHelp')}</p>
          <ContactInput
            placeholder={t('messagePlaceholder')}
            label=""
            value={userInquiry}
            onChange={setUserInquiry}
            setIsButtonDisabled={setIsButtonDisabled}
            height="123px"
            isTextArea="true"
          />
          <p className="mb-[10px] text-[14px] text-gray">{t('helpNote')}</p>
        </div>

        {/* <div className="mb-[40px]">
          <div ref={captchaRef} className="flex justify-center items-center w-full max-w-xs mx-auto" data-theme="light" ></div>
        </div> */}
        {isSubmitting && (
          <div className="w-full flex-col flex justify-center items-center absolute top-0 bg-white/70 backdrop-blur-[1px] h-full">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-amber-600 border-opacity-50"></div>
            <div className="text-center">{t('submitting')}</div>
          </div>
        )}
        <a
          className={`w-full max-w-[280px] h-[50px] mx-auto flex justify-center items-center bg-orange text-white font-semibold text-[23px] rounded-[3px] gap-1 shadow-heroBtnShadow group btn-primary ${isButtonDisabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}
          href="#"
          onClick={(e) => {
            if (isButtonDisabled) {
              e.preventDefault();
              return;
            }
            handleSubmit(e);
          }}
        >
          <span className="mb-[2px]">{t('submit')}</span>
          <span className={`${isButtonDisabled ? 'transform-none' : 'group-hover:translate-x-1.5'} transition-all`}>
            <svg className="" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_0_615)">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.82983 0.670075C2.29032 0.209585 3.03692 0.209585 3.49741 0.670073L9.61156 6.78422C9.83269 7.00535 9.95692 7.30528 9.95692 7.618C9.95692 7.93074 9.83269 8.23067 9.61156 8.4518L3.49741 14.5659C3.03692 15.0265 2.29032 15.0265 1.82983 14.5659C1.36934 14.1054 1.36934 13.3589 1.82983 12.8984L7.11019 7.618L1.82983 2.33765C1.36934 1.87716 1.36934 1.13056 1.82983 0.670075Z" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M8.9938 0.670075C9.45429 0.209585 10.2009 0.209585 10.6614 0.670073L16.7755 6.78422C16.9966 7.00535 17.1208 7.30528 17.1208 7.618C17.1208 7.93074 16.9966 8.23067 16.7755 8.4518L10.6614 14.5659C10.2009 15.0265 9.45429 15.0265 8.9938 14.5659C8.53332 14.1054 8.53332 13.3589 8.9938 12.8984L14.2742 7.618L8.9938 2.33765C8.53332 1.87716 8.53332 1.13056 8.9938 0.670075Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_0_615">
                  <rect width="17.0323" height="15.7221" fill="white" transform="translate(0.648438 0.193359)" />
                </clipPath>
              </defs>
            </svg>
          </span>
        </a>
     
      </section>
    </>
  );
};

export default ContactUS;
